import type { MouseEvent } from 'react';
import { useCurrentUserContext } from '@/contexts';
import { useIsMagic } from '@/hooks/useIsMagic';
import { Tabs as ChakraTabs, TabList } from '@/ui';
import { useTabIndex } from '../hooks/useTabIndex';
import { StyledNavLink } from './StyledNavLink';

export const Tabs = () => {
  const { isAuthenticated } = useCurrentUserContext();
  const { tabIndex } = useTabIndex();
  const { isMagic } = useIsMagic();

  // On /magic itself following the tab again would land on a bare /magic,
  // dropping the results, chat and picked output held in the URL.
  const handleMagicClick = (event: MouseEvent) => {
    if (isMagic) event.preventDefault();
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <ChakraTabs index={tabIndex} variant="unstyled">
      <TabList gap="2">
        <StyledNavLink selectedBgColor="#f4f2fa" to="/dashboard">
          Library
        </StyledNavLink>

        <StyledNavLink
          selectedBgColor="#fff"
          to="/magic"
          onClick={handleMagicClick}
        >
          Magic
        </StyledNavLink>
      </TabList>
    </ChakraTabs>
  );
};
